import { render, staticRenderFns } from "./blog-banner.vue?vue&type=template&id=3561db82&scoped=true&"
import script from "./blog-banner.vue?vue&type=script&lang=js&"
export * from "./blog-banner.vue?vue&type=script&lang=js&"
import style0 from "./blog-banner.vue?vue&type=style&index=0&id=3561db82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561db82",
  null
  
)

export default component.exports